import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Async thunk to handle the POST request for adding a new unit
export const addNewUnit = createAsyncThunk(
  'unit/addNewUnit',
  async ({newlyAddedUnitName,token}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Customer/AddNewUnit', newlyAddedUnitName, {
        headers: {
             'Content-Type': 'application/json-patch+json',
             'Authorization': `Bearer ${token}`, },
      
      });      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const unitSlice = createSlice({
  name: 'unit',
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addNewUnit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewUnit.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(addNewUnit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default unitSlice.reducer;
